module.exports = __webpack_public_path__ + "static/img/img34.6c9b435.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img34.png
// module id = UZ3n
// module chunks = 1